import PropTypes from "prop-types";
/* eslint-disable camelcase */
import React from "react";
import styleObjectToProps from "core-web/utils/styleObjectToProps";
import styled from "theme/libs/styled";
import textStylesConfig from "theme/config/textStyles";

const Text = styled("span")``;

/**
 *
 * @param {string | (string | null)[]} textStyles - Keys to access styles from textStylesConfig
 * @returns {object};
 */

const TextStyles = ({ as, is, textStyles, ...rest }) => {
    const css = styleObjectToProps(textStyles, textStylesConfig);
    const props = { ...css, ...rest };
    return <Text as={is || as || "p"} {...props} />;
};

TextStyles.propTypes = {
    as: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    is: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    textStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

TextStyles.defaultProps = {
    as: undefined,
    is: undefined,
    textStyles: "Myriad Pro/16-140",
};

export default TextStyles;
